<template>
  <div>
    <v-toolbar light color="#ffd300">
      <v-toolbar-title>
        <img
          src="@/assets/Pos/logo.png"
          alt="logo_weserve"
          class="logo-preview"
        />
      </v-toolbar-title>
      <div class="text-store-preview">STORE PREVIEW</div>
    </v-toolbar>
    <div style="display: flex; justify-content: center">
      <v-card class="card-box space-top">
        <div class="tab-menu">
          <v-layout row wrap class="py-2">
            <v-flex xs2 class="pl-2">
              <!-- <v-icon color="white">arrow_back</v-icon> -->
            </v-flex>
            <v-flex xs8>
              <div class="store-name">
                {{
                  store_data.store_name_th
                    ? store_data.store_name_th
                    : "Loading product...."
                }}
              </div>
            </v-flex>
            <v-flex xs2 class="pr-2 text-xs-right">
              <!-- <v-icon color="white">shopping_cart</v-icon> -->
            </v-flex>
          </v-layout>
          <!-- <v-img src="https://cdn.pixabay.com/photo/2017/12/09/08/18/pizza-3007395_1280.jpg" aspect-ratio="1.7"></v-img> -->
        </div>
        <v-card-text class="pa-0" style="height: 805px; overflow: scroll">
          <v-layout row wrap class="py-2">
            <v-flex class="pl-2">ประเภทอาหารภายในร้าน</v-flex>
            <div style="position: relative; text-align: right">
              <div
                :style="{
                  backgroundColor:
                    store_data.store_time &&
                    store_data.store_time.store_close == true
                      ? 'rgb(20, 167, 20)'
                      : 'red',
                  borderRadius: '50%',
                  width: '15px',
                  height: '15px',
                  position: 'absolute',
                  top: '5px',
                }"
              ></div>
              <div style="padding-left: 20px">
                {{
                  store_data.store_time &&
                  store_data.store_time.store_close == true
                    ? "ร้านเปิด"
                    : "ร้านปิด"
                }}
                <v-icon>info_outlines</v-icon>
              </div>
            </div>
          </v-layout>
          <!-- <span class="ml-2" style="background-color:#ffd300;border-radius:30px;line-height:30px;padding:5px 10px 0 10px;">ทั้งหมด</span>  -->

          <div class="type">
            <v-chip :disabled="selected_type == 0" @click="selectType(0)"
              >ทั้งหมด</v-chip
            >

            <v-chip
              v-for="(info, index) in store_data.product_type"
              :key="index"
              :disabled="selected_type == info.product_type_id"
              @click="selectType(info.product_type_id)"
              >{{ info.product_type_name_th }}</v-chip
            >
          </div>
          <div class="ml-2 mt-3">สินค้าที่จำหน่าย</div>
          <template
            v-for="(item, index) in this.store_data.products
              ? filterdProducts
              : []"
          >
            <v-divider :key="index"></v-divider>
            <div :key="item.title" class="px-3" style="cursor: pointer">
              <v-layout row align-center @click="openDialog(item.product_id)">
                <v-flex class="mt-2" style="flex: none">
                  <img
                    :src="item.product_image"
                    height="120px"
                    width="120px"
                    style="border-radius: 3px"
                  />
                </v-flex>
                <v-flex>
                  <ul style="list-style-type: none">
                    <li class="title-product">{{ item.product_name_th }}</li>
                    <li class="description-product">
                      {{ item.product_description_th }}
                    </li>
                    <li>
                      ราคา :
                      {{ parseFloat(item.product_sale_price).toFixed(2) }} THB
                    </li>
                  </ul>
                </v-flex>
              </v-layout>
            </div>
          </template>
          <v-dialog v-model="optionDialog" scrollable max-width="300px">
            <v-card>
              <v-toolbar dense flat color="transparent">
                <v-toolbar-title v-if="fetching_option == false"
                  >เพิ่มเติม</v-toolbar-title
                >
                <v-toolbar-title v-else>Loading option ...</v-toolbar-title>
                <v-spacer />
                <span
                  class="red--text"
                  style="cursor: pointer"
                  @click="optionDialog = false"
                  v-if="fetching_option == false"
                  >ปิด</span
                >
              </v-toolbar>
              <v-divider />
              <v-card-text
                v-if="option_data.length == 0 && fetching_option == false"
              >
                <div class="text-xs-center">ไม่มีตัวเลือกเพิ่มเติม</div>
              </v-card-text>
              <v-card-text
                v-for="(info_option, index_option) in option_data"
                :key="index_option"
              >
                {{ info_option.option_name_th }}
                {{
                  info_option.option_require == true ? "(จำเป็นต้องเลือก)" : ""
                }}
                <ul v-for="(item, index) in info_option.choice" :key="index">
                  <v-layout row>
                    <v-flex xs6>
                      <li>{{ item.choice_name_th }}</li>
                    </v-flex>
                    <v-flex xs6
                      >{{
                        parseFloat(item.choice_price).toFixed(2)
                      }}
                      THB</v-flex
                    >
                  </v-layout>
                </ul>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- <v-list three-line>
            <template v-for="(item, index) in store_data.products">
              <v-list-tile :key="item.title" class="pt-4 pb-3">
                <v-list-tile-action class="pr-3 pb-2">
                  <img 
>>>>>>> eda2f4586accb9cb6188beaa71ebb3d7f2b21694
                    :src="item.product_image"
                    style="border-radius:3px;height:120px;width:120px;"
                  >
                </v-list-tile-action>
                <v-list-tile-content style="width:230px;">
                  <v-list-tile-title v-html="item.product_name_th"></v-list-tile-title>
                  <v-list-tile-sub-title
                    style="font-size:12px;"
                    v-html="item.product_description_th"
                  ></v-list-tile-sub-title>
                  <v-list-tile-title style="font-size:13px;">ราคา : {{item.product_sale_price}} THB</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider :key="index"></v-divider>
            </template>
          </v-list>-->
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { coreInstance, backendVersion } from "@/axios-path.js";
export default {
  data() {
    return {
      fetching_option: false,
      selected_type: 0,
      store_data: {},
      option_data: [],
      optionDialog: false,
      radioGroup: 1,
      radioItems: [
        { choice: "กุ้ง", price: 120, value: 1 },
        { choice: "หมึก", price: 120, value: 2 },
        { choice: "หมูสามชั้นทอดกรอบ", price: 120, value: 3 },
        { choice: "หมึก", price: 120, value: 4 },
      ],
    };
  },
  computed: {
    filterdProducts() {
      if (this.selected_type == 0) {
        return this.store_data.products;
      } else {
        return this.store_data.products.filter((val) => {
          return val.product_type == this.selected_type;
        });
      }
    },
  },
  methods: {
    selectType(product_type) {
      if (this.selected_type != product_type) {
        this.selected_type = product_type;
      }
    },
    openDialog(product_id) {
      this.fetchOption(product_id);
      this.optionDialog = true;
      this.option_data = [];
    },
    fetchOption(product_id) {
      this.fetching_option = true;
      coreInstance
        .get(
          backendVersion.version +
            "/" +
            this.$route.params.province +
            "/Product/Option/" +
            product_id
        )
        .then((res) => {
          this.option_data = res.data;
          this.fetching_option = false;
        })
        .catch((err) => (this.fetching_option = false));
    },
  },
  created() {
    coreInstance
      .get(
        backendVersion.version +
          "/" +
          this.$route.params.province +
          "/StoreList/Product/" +
          this.$route.params.store_id
      )
      .then((res) => {
        this.store_data = res.data;
      })
      .catch((err) => console.log(err));
  },
};
</script>

<style scoped>
.logo-preview {
  padding-top: 10px;
  width: 200px;
}
.text-store-preview {
  padding-left: 15px;
  font-family: "GoldenPlains";
  font-size: 22px;
}
.card-box {
  height: 850px;
  width: 420px;
}
.store-name {
  background-color: white;
  border-radius: 30px;
  line-height: 30px;
  padding-left: 10px;
  font-size: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}
.tab-menu {
  background-color: #ffd300;
}
.type {
  width: 420px;
  max-height: 42px;
  overflow: auto;
  white-space: nowrap;
}
.title-product {
  width: 250px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.description-product {
  width: 250px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 13px;
  color: gray;
}
.space-top {
  margin-top: 25px;
}

@media screen and (max-width: 600px) {
  .space-top {
    margin-top: 0px;
  }
  .title-product {
    width: 240px;
  }
  .description-product {
    width: 240px;
  }
  .type {
    max-width: 420px;
  }
}
@media screen and (max-width: 375px) {
  .logo-preview {
    width: 170px;
  }
  .text-store-preview {
    font-size: 18px;
  }
  .title-product {
    width: 200px;
  }
  .description-product {
    width: 200px;
  }
  .type {
    max-width: 375px;
  }
}
@media screen and (max-width: 320px) {
  .logo-preview {
    width: 0px;
  }
  .text-store-preview {
    padding-left: 25%;
  }
  .title-product {
    width: 150px;
  }
  .description-product {
    width: 150px;
  }
  .type {
    max-width: 320px;
  }
}
</style>
